import { Box } from "@mui/material";
import { FC, Suspense } from "react";
import { Outlet } from "react-router-dom";
import RouteFallback from "RouteFallback";

const Master: FC = () => {
  return (
    <Box height="91%">
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
    </Box>
  );
};
export default Master;
